var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("request_details")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("order_number"), disable: "" },
              model: {
                value: _vm.order_number,
                callback: function($$v) {
                  _vm.order_number = $$v
                },
                expression: "order_number"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("reward_title"), disable: "" },
              model: {
                value: _vm.reward_title,
                callback: function($$v) {
                  _vm.reward_title = $$v
                },
                expression: "reward_title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("reward_type"), disable: "" },
              model: {
                value: _vm.reward_type,
                callback: function($$v) {
                  _vm.reward_type = $$v
                },
                expression: "reward_type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("price"), disable: "" },
              model: {
                value: _vm.price,
                callback: function($$v) {
                  _vm.price = $$v
                },
                expression: "price"
              }
            })
          ],
          1
        ),
        _vm.reward_redeen_code != null
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("reward_redeen_code"),
                    disable: ""
                  },
                  model: {
                    value: _vm.reward_redeen_code,
                    callback: function($$v) {
                      _vm.reward_redeen_code = $$v
                    },
                    expression: "reward_redeen_code"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("created_date"), disable: "" },
              model: {
                value: _vm.created_date,
                callback: function($$v) {
                  _vm.created_date = $$v
                },
                expression: "created_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("updated_date"), disable: "" },
              model: {
                value: _vm.updated_date,
                callback: function($$v) {
                  _vm.updated_date = $$v
                },
                expression: "updated_date"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("requester_data")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("full_name"), disable: "" },
              model: {
                value: _vm.full_name,
                callback: function($$v) {
                  _vm.full_name = $$v
                },
                expression: "full_name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("email"), disable: "" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("div", { staticClass: "row gutter-xs" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("q-input", {
                  attrs: { "float-label": _vm.$t("country_code"), disable: "" },
                  model: {
                    value: _vm.phone_mobile.country_code,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "country_code", $$v)
                    },
                    expression: "phone_mobile.country_code"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("q-input", {
                  attrs: { "float-label": _vm.$t("city_code"), disable: "" },
                  model: {
                    value: _vm.phone_mobile.area_code,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "area_code", $$v)
                    },
                    expression: "phone_mobile.area_code"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("q-input", {
                  attrs: { "float-label": _vm.$t("phone_mobile"), disable: "" },
                  model: {
                    value: _vm.phone_mobile.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.phone_mobile, "phone", $$v)
                    },
                    expression: "phone_mobile.phone"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 q-mt-lg flex justify-between" },
          [
            _c("span", { staticClass: "q-headline text-weight-light" }, [
              _vm._v(_vm._s(_vm.$t("requester_address")))
            ])
          ]
        ),
        _vm.keyGooogleMaps
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.show_maps_alert,
                      "error-label": _vm.$t(
                        "not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code"
                      )
                    }
                  },
                  [
                    _c(
                      "q-input",
                      {
                        attrs: {
                          "float-label": _vm.$t("address"),
                          autocomplete: "new-password",
                          placeholder: _vm.$t(
                            "search_by_name_and_street_number"
                          ),
                          error: _vm.$v.address.$error
                        },
                        on: { input: _vm.$v.address.$touch },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3, separator: "" },
                          on: {
                            search: _vm.getAddressGoogleMaps,
                            selected: _vm.selectedAddressGoogleMaps
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-input",
                  {
                    attrs: {
                      "float-label": _vm.$t("address"),
                      autocomplete: "new-password",
                      error: _vm.$v.address.$error
                    },
                    on: { input: _vm.$v.address.$touch },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 3, separator: "" },
                      on: {
                        search: _vm.getAddress,
                        selected: _vm.selectedAddress
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              ref: "number",
              attrs: {
                "float-label": _vm.$t("number"),
                error: _vm.$v.number.$error
              },
              on: { input: _vm.$v.number.$touch },
              model: {
                value: _vm.number,
                callback: function($$v) {
                  _vm.number = $$v
                },
                expression: "number"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("complement") },
              model: {
                value: _vm.complement,
                callback: function($$v) {
                  _vm.complement = $$v
                },
                expression: "complement"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("neighborhood"),
                error: _vm.$v.neighborhood.$error
              },
              on: { input: _vm.$v.neighborhood.$touch },
              model: {
                value: _vm.neighborhood,
                callback: function($$v) {
                  _vm.neighborhood = $$v
                },
                expression: "neighborhood"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("postal_code"),
                error: _vm.$v.postal_code.$error
              },
              on: { input: _vm.$v.postal_code.$touch },
              model: {
                value: _vm.postal_code,
                callback: function($$v) {
                  _vm.postal_code = $$v
                },
                expression: "postal_code"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("city"),
                error: _vm.$v.city.$error
              },
              on: { input: _vm.$v.city.$touch },
              model: {
                value: _vm.city,
                callback: function($$v) {
                  _vm.city = $$v
                },
                expression: "city"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("state"),
                error: _vm.$v.state.$error
              },
              on: { input: _vm.$v.state.$touch },
              model: {
                value: _vm.state,
                callback: function($$v) {
                  _vm.state = $$v
                },
                expression: "state"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "row justify-between q-mt-lg" },
        [
          _c(
            "q-chip",
            {
              attrs: {
                square: "",
                icon: _vm.getIconStatus(_vm.status),
                color: _vm.getColorStatus(_vm.status)
              }
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t(_vm.getStatus(_vm.status))) +
                  "\n\t\t"
              )
            ]
          ),
          _c("q-btn", {
            attrs: {
              color: "secondary",
              icon: "far fa-save",
              label: _vm.$t("save_address")
            },
            on: {
              click: function($event) {
                return _vm.saveAddress()
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _vm.status === 1
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("cancel")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: _vm.getButtonColorTwo(_vm.status),
                    label: _vm.$t(_vm.getButtonTwo(_vm.status)),
                    icon: _vm.getButtonIconTwo(_vm.status)
                  },
                  on: {
                    click: function($event) {
                      _vm.alterStatus((_vm.value = 3))
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.status === 1
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: _vm.getButtonColorOne(_vm.status),
                    label: _vm.$t(_vm.getButtonOne(_vm.status)),
                    icon: _vm.getButtonIconOne(_vm.status)
                  },
                  on: {
                    click: function($event) {
                      _vm.alterStatus((_vm.value = 2))
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.historys.length > 0
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "primary",
                    label: _vm.$t("status_history"),
                    icon: "far fa-eye"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_timeline = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.status === 2
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: _vm.getButtonColorOne(_vm.status),
                    label: _vm.$t(_vm.getButtonOne(_vm.status)),
                    icon: _vm.getButtonIconOne(_vm.status)
                  },
                  on: {
                    click: function($event) {
                      _vm.alterStatus((_vm.value = 4))
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.status === 4
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: _vm.getButtonColorTwo(_vm.status),
                    label: _vm.$t(_vm.getButtonTwo(_vm.status)),
                    icon: _vm.getButtonIconTwo(_vm.status)
                  },
                  on: {
                    click: function($event) {
                      _vm.alterStatus((_vm.value = 5))
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidthComment,
              minHeight: "30vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_timeline,
            callback: function($$v) {
              _vm.show_timeline = $$v
            },
            expression: "show_timeline"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_timeline = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("timeline_status")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c(
                    "q-timeline",
                    {
                      staticStyle: { padding: "0 15px" },
                      attrs: { responsive: "", color: "secondary" }
                    },
                    [
                      _c("q-timeline-entry", { attrs: { heading: "" } }, [
                        _vm._v(_vm._s(_vm.$t("status_history")))
                      ]),
                      _vm._l(_vm.historys, function(history) {
                        return _c(
                          "q-timeline-entry",
                          {
                            key: history.id,
                            attrs: {
                              title: _vm.$t(_vm.getStatus(history.status)),
                              subtitle: _vm.getDateFormated(
                                history.created_date
                              ),
                              side: "right",
                              color: _vm.getColorStatus(history.status),
                              icon: _vm.getIconStatus(history.status)
                            }
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "q-mt-none q-md-none" },
                                [_vm._v(_vm._s(history.user_full_name))]
                              ),
                              _c("br"),
                              _c(
                                "span",
                                { staticClass: "text-weight-thin q-mt-none" },
                                [_vm._v(_vm._s(history.user_email))]
                              ),
                              _c("br"),
                              _c(
                                "p",
                                { staticClass: "text-weight-light q-mt-md" },
                                [_c("i", [_vm._v(_vm._s(history.observation))])]
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "50vh",
              maxHeight: "70vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_comment_status,
            callback: function($$v) {
              _vm.show_comment_status = $$v
            },
            expression: "show_comment_status"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_comment_status = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(" " + _vm._s(_vm.$t("status_comment")) + "* ")
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("do_you_really_want_to_perform_this_action")
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "5",
                          "float-label": _vm.$t("comment"),
                          error: _vm.$v.comment_status.$error
                        },
                        on: { input: _vm.$v.comment_status.$touch },
                        model: {
                          value: _vm.comment_status,
                          callback: function($$v) {
                            _vm.comment_status = $$v
                          },
                          expression: "comment_status"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _vm.statuses === 2
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: _vm.getButtonColorOne(_vm.status),
                                label: _vm.$t(_vm.getButtonOne(_vm.status)),
                                icon: _vm.getButtonIconOne(_vm.status)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveData()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.statuses === 3
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: _vm.getButtonColorTwo(_vm.status),
                                label: _vm.$t(_vm.getButtonTwo(_vm.status)),
                                icon: _vm.getButtonIconTwo(_vm.status)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveData()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.statuses === 4
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: _vm.getButtonColorOne(_vm.status),
                                label: _vm.$t(_vm.getButtonOne(_vm.status)),
                                icon: _vm.getButtonIconOne(_vm.status)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveData()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.statuses === 5
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: _vm.getButtonColorTwo(_vm.status),
                                label: _vm.$t(_vm.getButtonTwo(_vm.status)),
                                icon: _vm.getButtonIconTwo(_vm.status)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveData()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }